var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form-label", {
    attrs: {
      label: _vm.label,
      "class-name": _vm.formLabelClassName,
      "form-class-name": _vm.formClassName,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "label",
          fn: function () {
            return [_vm._t("label")]
          },
          proxy: true,
        },
        {
          key: "header",
          fn: function () {
            return [_vm._t("header")]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [
              _c("input", {
                staticClass: "boss-input",
                class: _vm.numberClassName,
                attrs: {
                  type: "number",
                  max: _vm.maxNumber,
                  min: _vm.minNumber,
                  placeholder: _vm.placeholder,
                  "data-test": _vm.dataTest,
                },
                domProps: { value: _vm.value },
                on: { keypress: _vm.keypress, input: _vm.update },
              }),
              _vm._v(" "),
              _vm._t("suffix"),
            ]
          },
          proxy: true,
        },
        {
          key: "error",
          fn: function () {
            return [
              _vm._l(_vm.errors, function (error, i) {
                return [
                  error.isShow
                    ? _c("validation-label", {
                        key: i,
                        attrs: {
                          "data-test": "error-" + i,
                          label: error.message,
                        },
                      })
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }